import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ButtonMenubar from 'atoms/ButtonMenubar/ButtonMenubar';
import Logo from 'atoms/Logo/Logo';
import InboxSvg from 'images/v5/icons/menu/inbox.svg';
import NotificationsSvg from 'images/v5/icons/menu/notifications.svg';
import Loader from 'layout/atoms/Loader/Loader';
import LogoSign from 'layout/atoms/LogoSign/LogoSign';
import NotificationsDropdown from 'layout/organisms/NotificationsDropdown';
import DropdownUser from 'organisms/DropdownUser';
import { selectInboxUnreadCount } from 'store/inboxSlice';
import { selectUnreadNotifications } from 'store/notificationsSlice';
import { selectUserProfileDataStatus } from 'store/userSlice';
import packageJson from '../../../../package.json';
import menubarContent from '../../../constants/menubarItems';
import styles from './Menubar.module.scss';
function Menubar() {
    const { t } = useTranslation(['LAYOUT']);
    const layoutState = useSelector((state) => state.layout);
    const userProfileStatus = useSelector(selectUserProfileDataStatus);
    const inboxUnreadCount = useSelector(selectInboxUnreadCount);
    const unreadNotificationsCount = useSelector(selectUnreadNotifications).length;
    const wrapClasses = classNames(styles.wrap, styles.active, {
        [`${styles.full}`]: layoutState.showMenu,
    });
    const headerClasses = classNames(styles.header, {
        [`${styles.full}`]: layoutState.showMenu,
    });
    const labelClasses = classNames(styles.label, {
        [`${styles.full}`]: layoutState.showMenu,
    });
    return (React.createElement("nav", { className: wrapClasses },
        React.createElement("header", { className: headerClasses },
            React.createElement(Logo, null),
            React.createElement(LogoSign, null)),
        React.createElement("main", { className: styles.main }, menubarContent.map((group) => group.main && (React.createElement("div", { className: styles.group, key: group.label || 'main' },
            group.label && React.createElement("h2", { className: labelClasses }, t(group.label)),
            group.items.map((item) => (React.createElement(ButtonMenubar, { key: item.slug || item.name, to: item.slug || '/', icon: item.icon, text: t(item.name), disabled: !!item.disabled }))))))),
        React.createElement("footer", { className: styles.footer }, userProfileStatus === 'succeeded' ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames(styles.group, styles.footerGroup) },
                React.createElement(NotificationsDropdown, null,
                    React.createElement(ButtonMenubar, { icon: React.createElement(NotificationsSvg, null), text: t('SIDEBAR_MENU_NOTIFICATIONS'), notifications: unreadNotificationsCount })),
                React.createElement(ButtonMenubar, { to: "/inbox", icon: React.createElement(InboxSvg, null), text: t('SIDEBAR_MENU_MESSAGES'), notifications: inboxUnreadCount })),
            React.createElement(DropdownUser, null))) : (React.createElement(Loader, null))),
        React.createElement(NavLink, { to: "/releases", className: classNames(styles.version, { [styles.show]: layoutState.showMenu }), style: { textDecoration: 'none' }, title: t('SIDEBAR_MENU_CHANGELOG') },
            "v",
            packageJson.version)));
}
export default Menubar;
